import React, { Component } from 'react'
import { ControlLabel, FormControl, Row, Col, Button, FormGroup } from 'react-bootstrap'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { makeUniqueKey } from '../helper';


class ExtraLeagueInfo extends Component {
  constructor(props) {
    super();
    this.state = {
      addTeamFee: false,
      addPlayerFee: false,
      teamFeeHint: false,
      playerFeeHint: false,
      teamProfitHint: false,
      teamFlexHint: false,
      teamMaxHint: false,
      playerProfitHint: false,
      playerFlexHint: false,
      playerMaxHint: false
    }
  }

  planSelector = (type) => {
    const { defaultPlaceholders } = this.props
    var calculateProjectedProfits = this.props.calculateProjectedProfits
    return (
      <div>
        <Col sm={6}>
          <Row>
            <Col sm={4} className="form-group">
              <ControlLabel>Enrol Goal</ControlLabel>
              <FormControl className="opaque-grey" name={`${type}_goal`} id={`${type}_goal`} type="number" min="0"  onChange={() => calculateProjectedProfits(`${type}_goal`, `${type}_costs`, `${type}_profit`)} defaultValue={type === 'player' ? defaultPlaceholders.player_goal : defaultPlaceholders.enrollment_goal} />
            </Col>
            <Col sm={4} className="form-group">
              <ControlLabel>Enrol Max
              <a className="hint-tip" onClick={() => this.setState({ [`${type}MaxHint`]: !this.state[`${type}MaxHint`] })}>
                <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                {
                  this.state[`${type}MaxHint`] ?
                <div className="hint-tip-text" id="name-hint">
                  <span>When the Enrolment Max is reached the status changes from OPEN to WAITLIST - OPEN.
                  </span>
                </div>
                : ''
                }
              </a>
              </ControlLabel>
              <FormControl className="opaque-grey" name={`${type}_max`} id={`${type}_max`} type="number" min="0" defaultValue={type === 'player' ? defaultPlaceholders.player_max : defaultPlaceholders.enrollment_maximum}/>
            </Col>
            <Col sm={4} className="form-group">
              <ControlLabel>Enrol Flex
                <a className="hint-tip" onClick={() => this.setState({ [`${type}FlexHint`]: !this.state[`${type}FlexHint`] })}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  {
                    this.state[`${type}FlexHint`] ?
                  <div className="hint-tip-text" id="name-hint">
                    <span>The number of players in excess of the Enrolment Max that can accept invitations from the waitlist
                    </span>
                  </div>
                  : ''
                  }
                </a>
              </ControlLabel>
              <FormControl className="opaque-grey" name={`${type}_flex`} id={`${type}_flex`} type="number" min="0" defaultValue={type === 'player' ? defaultPlaceholders.player_flex : defaultPlaceholders.enrolment_flex}/>
            </Col>
          </Row>
          <Row>
            <Col sm={6} className="form-group">
              <ControlLabel>Your Expected Costs</ControlLabel>
              <FormControl className="opaque-grey" name={`${type}_costs`} id={`${type}_costs`} type="number" onChange={() => calculateProjectedProfits(`${type}_goal`, `${type}_costs`, `${type}_profit`)} defaultValue={type === 'player' ? defaultPlaceholders.player_costs : defaultPlaceholders.expected_costs}/>
            </Col>
            <Col sm={6} className="form-group">
              <ControlLabel>Your Projected Profits
                <a className="hint-tip" onClick={() => this.setState({ [`${type}ProfitHint`]: !this.state[`${type}ProfitHint`]})}>
                  <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                  {
                    this.state[`${type}ProfitHint`] ?
                  <div className="hint-tip-text" id="name-hint">
                    <span>Plan x Enrolment Goal - Expected Costs = Projected Profits
                    </span>
                  </div>
                  : ''
                  }
                </a>
              </ControlLabel>
              <FormControl placeholder="Automatically calculated" className="opaque-grey" name={`${type}_profit`} id={`${type}_profit`} type="number" disabled defaultValue={type === 'player' ? defaultPlaceholders.player_profit : defaultPlaceholders.projected_program_profits} />
            </Col>
          </Row>
        </Col>
      </div>
    )
  }

  render() {
    const { renderPlans } = this.props
    return(
      <div>
        <Row>
          <h3 style={{marginTop: '20px'}} className="col-sm-12">Enrolment Parameters for Teams
          
          </h3>
          </Row>
          <Row>
            <Col sm={6}>
              <ControlLabel>Team Fees&nbsp;
                <a className="heading-hint" onClick={() => this.setState({ teamFeeHint: !this.state.teamFeeHint })}>
                <FontAwesomeIcon icon={faInfoCircle} color='white'/>
                {
                  this.state.teamFeeHint ?
                <div className="hint-tip-text" id="payment-hint">
                  <span>Team fees are paid by teams to enter the league.</span>
                </div>
                : ''
                }
              </a>
              </ControlLabel>
              {renderPlans('team_fee_plan', 'team_goal', 'team_costs', 'team_profit', 'team_fees')}
          </Col>
          {this.planSelector('team')}
        </Row>
        <hr/>
        <Row style={{marginTop: '0'}}>
          <h3 style={{marginTop: '0'}} className="col-sm-12">Enrolment Parameters for Players
          </h3>
        </Row>
        <Row>
        <Col sm={6}>
          <ControlLabel>Player Fees&nbsp;
            <a className="heading-hint" onClick={() => this.setState({ playerFeeHint: !this.state.playerFeeHint })}>
              <FontAwesomeIcon icon={faInfoCircle} color='white'/>
              {
                this.state.playerFeeHint ?
              <div className="hint-tip-text" id="payment-hint">
                <span>Player fees are paid by players to enter the league.</span>
              </div>
              : ''
              }
            </a>
          </ControlLabel>
          {renderPlans('player_fee_plan', 'player_goal', 'player_costs', 'player_profit', 'player_fees')}
        </Col>
        {this.planSelector('player')}
      </Row>
              {/*<hr/>
              <div>
          <h3>Additional Rules</h3>
          <Row>
            <Col sm={3}>
              <ControlLabel>Max. teams per club</ControlLabel>
              <FormControl className="opaque-grey" name="" id="" type="number" min="0" />
            </Col>
            <Col sm={3}>
              <ControlLabel>Max. players per club</ControlLabel>
              <FormControl className="opaque-grey" name="" id="" type="number" min="0" />
            </Col>
            <Col sm={3}>
              <ControlLabel>DOB Max</ControlLabel>
              <FormControl className="opaque-grey" name="" id="" type="number" min="0" />
            </Col>
          </Row>
        </div>
        <h3>User Defined Fields</h3>
        <Row>
          <Col sm={3}>
            <ControlLabel>Enrolment Form Section</ControlLabel>
            <FormControl className="opaque-grey" name="" id="" componentClass="select" min="0">
              {section}
            </FormControl>
          </Col>
          <Col sm={3}>
            <ControlLabel>Field Name</ControlLabel>
            <FormControl className="opaque-grey" name="" id="" type="text" />
          </Col>
          <Col sm={3} className="save-field-btn">
            <Button className="orange-outline">Save Field</Button>
          </Col>
        </Row>
        <Row>
          <Col sm={4} style={{marginTop: '1em'}}>
            <Button className="orange-outline">Add Enrolment Form Field</Button>
          </Col>
        </Row> */}
    </div> 

    )
  }
}

export default ExtraLeagueInfo